function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/helpers/nonIterableSpread.js
// module id = ../node_modules/@babel/runtime/helpers/nonIterableSpread.js
// module chunks = 0